/**
 * @generated SignedSource<<8de365a20d72f0c75ffe3f42d45e0cf5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBuyerProtectionGuarantee_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly tradeFirm?: {
    readonly rewards: {
      readonly currentProgram: {
        readonly programInfo: {
          readonly code: string | null;
        } | null;
        readonly childPrograms: ReadonlyArray<{
          readonly code: string | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
  readonly " $fragmentType": "PdpSharedBuyerProtectionGuarantee_user";
};
export type PdpSharedBuyerProtectionGuarantee_user$key = {
  readonly " $data"?: PdpSharedBuyerProtectionGuarantee_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyerProtectionGuarantee_user">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBuyerProtectionGuarantee_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "condition": "isTrade",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "kind": "LinkedField",
          "name": "tradeFirm",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TradeFirmRewards",
              "kind": "LinkedField",
              "name": "rewards",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ParentProgram",
                  "kind": "LinkedField",
                  "name": "currentProgram",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LoyaltyProgram",
                      "kind": "LinkedField",
                      "name": "programInfo",
                      "plural": false,
                      "selections": (v0/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "filter",
                          "value": "ENHANCED_BUYER_PROTECTION"
                        }
                      ],
                      "concreteType": "LoyaltyProgram",
                      "kind": "LinkedField",
                      "name": "childPrograms",
                      "plural": true,
                      "selections": (v0/*: any*/),
                      "storageKey": "childPrograms(filter:\"ENHANCED_BUYER_PROTECTION\")"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "69ee5b2c2e797860e6a479ce47e9b82e";

export default node;
